type PixelPattern = 'corner' | 'frame' | 'scatter' | 'steps';
type PixelTone = 'blue' | 'orange' | 'red' | 'mixed';

interface PixelSquaresProps {
    pattern?: PixelPattern;
    tone?: PixelTone;
    className?: string;
    sizeClassName?: string;
    opacityClassName?: string;
}

const patterns: Record<PixelPattern, number[]> = {
    corner: [0, 1, 6, 7, 12, 18, 24, 25, 31],
    frame: [0, 2, 4, 7, 9, 11, 12, 13, 14, 17, 18, 24, 30, 31, 32, 33],
    scatter: [1, 4, 8, 14, 19, 22, 27, 33],
    steps: [0, 6, 7, 13, 18, 19, 25, 31, 32],
};

const toneClasses: Record<Exclude<PixelTone, 'mixed'>, string> = {
    blue: 'bg-brand-bg',
    orange: 'bg-brand-text',
    red: 'bg-brand-cta',
};

function getPixelClass(tone: PixelTone, index: number) {
    if (tone !== 'mixed') return toneClasses[tone];

    if (index % 7 === 0) return toneClasses.red;
    return index % 2 === 0 ? toneClasses.blue : toneClasses.orange;
}

export default function PixelSquares({
    pattern = 'corner',
    tone = 'orange',
    className = '',
    sizeClassName = 'w-36 md:w-56',
    opacityClassName = 'opacity-30',
}: PixelSquaresProps) {
    const filledCells = new Set(patterns[pattern]);

    return (
        <div
            aria-hidden="true"
            className={`pointer-events-none absolute ${sizeClassName} ${opacityClassName} ${className}`}
        >
            <div className="grid grid-cols-6 gap-0">
                {Array.from({ length: 36 }).map((_, index) => (
                    <div key={index} className="aspect-square">
                        {filledCells.has(index) && (
                            <div className={`h-full w-full ${getPixelClass(tone, index)}`} />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
